import { Component, OnInit } from "@angular/core";
import { UserRoleservice } from "../Services/common.service";
import { DocumentService } from "../Services/Documents/document.service";

@Component({
    selector: 'app-emergencyUserAcess',
    // template: '<span id="IsEmergencyUserAcess" class="alert alert-danger"  style="z-index: 1020;bottom:1px;position: absolute;text-align: center;display:none; width:100%;margin-bottom: 0px;" >Emergency User Access Enabled  <button (click)="fnDIsableAccess()">Disable Access</button></span>'
    template: '<span id="IsEmergencyUserAcess" class="alert alert-danger"  style="z-index: 1020;bottom:1px;position: absolute;text-align: center;display:none; width:100%;margin-bottom: 0px;" >Emergency User Access Enabled </span>'
})
export class EmergencyUserAcessComponent implements OnInit {
    interval
    constructor(
        private _DocumentService: DocumentService,
        private _userRoleservice: UserRoleservice
    ) {

    }
    fnDIsableAccess() {
        const inputData: any = {
            id: 0,
            roleid: '',
            userid: encodeURIComponent(sessionStorage.getItem("userId")),
            permissions: '',
            LoginUser: encodeURIComponent(sessionStorage.getItem("userId")),
            isActive: false,
            serverresponse: ""
        };
        this._DocumentService.EmergencyUserPermissions(inputData, "ADD").subscribe(res => {
            document.getElementById("IsEmergencyUserAcess").style.display = 'none';
            this._userRoleservice.GetComponentRolePermissions();
            window.location.reload();


        });

    }
    ngOnInit(): void {
        //const documentService = this._DocumentService;
        this.interval = setInterval(() => {
            if (sessionStorage.getItem("userId")) {
                clearInterval(this.interval);
                if (sessionStorage.getItem("EnableEmergencyAccess"))
                    document.getElementById("IsEmergencyUserAcess").style.display = 'block';
                else
                    document.getElementById("IsEmergencyUserAcess").style.display = 'none';

                // const inputData: any = {
                //     userid: encodeURIComponent(sessionStorage.getItem("userId")),
                // };
                // documentService.EmergencyUserPermissions(inputData, 'SELECTBYUSERID').subscribe(res => {
                //     if (res && res.length > 0)
                //         document.getElementById("IsEmergencyUserAcess").style.display = 'block';
                //     else
                //         document.getElementById("IsEmergencyUserAcess").style.display = 'none';
                // },
                //     (error: any) => {
                //         document.getElementById("IsEmergencyUserAcess").style.display = 'none';

                //     }
                // );

            }
        }, 1000);

    }

}